export default __webpack_public_path__ + "static/media/svelte.69ae2b91.gif";